import { createPortal } from "react-dom";

/**
 * Full-Screen Viewport Ambient Vignette (Aura)
 * Renders a soft, feathered ambient vignette across the entire viewport on actual win or loss.
 * Soft ambient gradient & diffused glow — no crisp or harsh neon edge lines.
 */
export function InFlightDuelOverlay({
  duelState = "idle", // 'idle' | 'won' | 'loss'
  active = false,
}) {
  const normalizedState = (duelState || "").toLowerCase();
  const isWinning = normalizedState === "won" || normalizedState === "win" || normalizedState === "winning";
  const isLosing =
    normalizedState === "loss" ||
    normalizedState === "lost" ||
    normalizedState === "lose" ||
    normalizedState === "losing";

  const isVisible = active || isWinning || isLosing;
  if (!isVisible || (!isWinning && !isLosing) || typeof document === "undefined") {
    return null;
  }

  const primaryRgba = isWinning ? "16, 185, 129" : "239, 68, 68";

  return createPortal(
    <div
      aria-hidden="true"
      style={{
        position: "fixed",
        inset: 0,
        width: "100vw",
        height: "100vh",
        pointerEvents: "none",
        zIndex: 99999,
        transition: "opacity 0.35s ease",
      }}
    >
      <style>{`
        @keyframes softAmbientPulse {
          0%, 100% {
            opacity: 0.78;
          }
          50% {
            opacity: 1;
          }
        }
      `}</style>

      {/* Soft Ambient Vignette: Feathered radial gradient + diffused multi-stop inset shadow, no crisp borders */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          background: `radial-gradient(ellipse at center, transparent 62%, rgba(${primaryRgba}, 0.22) 100%)`,
          boxShadow: `inset 0 0 50px rgba(${primaryRgba}, 0.35), inset 0 0 100px rgba(${primaryRgba}, 0.16)`,
          animation: "softAmbientPulse 2.4s infinite ease-in-out",
        }}
      />
    </div>,
    document.body
  );
}
